(function($) {

	'use strict';

	var init = function() {
		toggleAccordion();
	};

	var toggleAccordion = function() {
		$('.contentAccordion__item').click(function() {
			var tab = $('#' + $(this).data('switch'))

			if($(this).hasClass('open')) {
				$(this).removeClass('open')
				tab.slideUp()
			} else {
				$('.contentAccordion__item').removeClass('open')
				$('.contentAccordion__content').slideUp()
				$(this).toggleClass('open')
				tab.slideToggle()
			}
		})
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
